/// <amd-module name="Wit/Common/WorkItemDialogs/Components/EditorDirtyDialog" />
import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { Dialog } from "VSSUI/Dialog";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";
import { QueryHierarchyItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import * as Resources from "Wit/Common/WorkItemDialogs/Resources";

export interface IEditorDirtyDialogProps {
    onDismiss: () => void;
    onLeave: () => void;
    onSave: () => void;
    query?: QueryHierarchyItem;
}

export const EditorDirtyDialog: React.FunctionComponent<IEditorDirtyDialogProps> = ({ onDismiss, onLeave, onSave, query }) => {
    const [errorMessage, setErrorMessage] = React.useState<string | undefined>(undefined);
    const onSaveClick = () => {
        try {
            onSave();
        } catch (error) {
            setErrorMessage(error.message);
        }
    };

    return (
        <Dialog
            footerButtonProps={[
                {
                    text: Resources.Cancel,
                    onClick: onDismiss
                },
                {
                    text: Resources.DiscardChanges,
                    onClick: onLeave
                },
                {
                    text: Resources.SaveChanges,
                    onClick: onSaveClick,
                    primary: true
                }
            ]}
            onDismiss={onDismiss}
            resizable={true}
            titleProps={{ text: Resources.EditorDirtyDialog }}
        >
            <div className="flex-column rhythm-vertical-8">
                {errorMessage && <MessageCard severity={MessageCardSeverity.Error}>{errorMessage}</MessageCard>}
                <span>{Resources.UnsavedChangesDirtyDialog}</span>
                <span>{format(Resources.RevertQuery, query ? query.name : Resources.UntitledQuery)}</span>
                <span>{Resources.EditorDirtyDialogMessage}</span>
            </div>
        </Dialog>
    );
};
